import React, { useState, useEffect } from 'react';
import { logo, profileImage, profileAvatar } from './ImageList';
import { useNavigate } from 'react-router-dom';
import { useFilter } from '../context/FilterContext';
import LanguageSelector from './LanguageSelector';
import { useTranslation } from 'react-i18next';

export default function MobileHeader({ setTransferProps }) {
    const navigate = useNavigate();
    const { toggleFilterPopup } = useFilter();
    const { t } = useTranslation();
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const dropdownRef = React.useRef(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    useEffect(() => {
        const fname = localStorage.getItem('consumerFirstName') || '';
        const lname = localStorage.getItem('consumerLastName') || '';
        setFirstName(fname);
        setLastName(lname);
    }, []);

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };
    function logout() {
        localStorage.removeItem('userID');
        localStorage.removeItem('agentKey');
        navigate('/');
    }

    return (
        <header className="mobile-header">
            <div className="mobile-header-top">
                {/* <div classNameName="mobile-back-btn" aria-label="Back" onClick={() => window.history.back()}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M12.5 15L7.5 10L12.5 5" stroke="#0E0E0E" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div> */}
                <div className="mobile-user-profile">

                    <div className="user-info dropdown" ref={dropdownRef}>
                        <div
                            className="dropdown-toggle"
                            role="button"
                            onClick={toggleDropdown}
                            aria-expanded={isDropdownOpen}
                        >
                            <img src={localStorage.getItem('consumerProfileImage')} alt="Profile" className="mobile-profile-img" />
                            <span>{t('hello')}, <br />{localStorage.getItem('consumerFirstName')} {localStorage.getItem('consumerLastName')}</span>
                        </div>
                        <ul className={`dropdown-menu dropdown-menu-start ${isDropdownOpen ? 'show' : ''}`}>
                            <li><button className="dropdown-item" onClick={() => logout()}>{t('logout')}</button></li>
                        </ul>
                    </div>
                </div>

                <div className="mobile-user-actions flex align-items-center gap-2">

                    <div className="mobile-notification-btn" aria-label="Notifications" onClick={() => navigate('/notifications')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 30 30" fill="none">
                            <path
                                d="M25.786 19.9986C25.6888 19.8814 25.5933 19.7643 25.4995 19.6512C24.2105 18.092 23.4306 17.151 23.4306 12.7371C23.4306 10.452 22.8839 8.57695 21.8064 7.1707C21.0118 6.13184 19.9378 5.34375 18.5222 4.76133C18.504 4.75119 18.4877 4.7379 18.4741 4.72207C17.965 3.01699 16.5716 1.875 15.0001 1.875C13.4286 1.875 12.0359 3.01699 11.5267 4.72031C11.5131 4.73556 11.497 4.74843 11.4792 4.7584C8.1757 6.11836 6.57023 8.72754 6.57023 12.7354C6.57023 17.151 5.79152 18.092 4.50129 19.6494C4.40754 19.7625 4.31203 19.8773 4.21476 19.9969C3.96351 20.2999 3.80433 20.6685 3.75604 21.0592C3.70775 21.4498 3.77239 21.8461 3.9423 22.2012C4.30382 22.9629 5.07433 23.4357 5.95382 23.4357H24.0528C24.9282 23.4357 25.6935 22.9635 26.0562 22.2053C26.2268 21.8501 26.2921 21.4535 26.2442 21.0624C26.1963 20.6713 26.0373 20.3021 25.786 19.9986Z"
                                fill="#1C4CAF" />
                            <path
                                d="M14.9999 28.125C15.8466 28.1243 16.6773 27.8945 17.404 27.4599C18.1306 27.0253 18.7261 26.4021 19.1272 25.6564C19.1461 25.6207 19.1555 25.5807 19.1543 25.5403C19.1532 25.4999 19.1416 25.4605 19.1208 25.4258C19.0999 25.3912 19.0704 25.3626 19.0352 25.3427C19 25.3229 18.9602 25.3125 18.9198 25.3125H11.0811C11.0407 25.3124 11.0009 25.3227 10.9656 25.3425C10.9303 25.3623 10.9007 25.391 10.8798 25.4256C10.8588 25.4602 10.8472 25.4997 10.846 25.5401C10.8449 25.5806 10.8542 25.6207 10.8731 25.6564C11.2742 26.402 11.8696 27.0251 12.5961 27.4597C13.3227 27.8943 14.1533 28.1242 14.9999 28.125Z"
                                fill="#1C4CAF" />
                        </svg>
                    </div>
                    <LanguageSelector />
                </div>
            </div>

        </header>
    );
}